// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/chunk/" + chunkId + ".chunk." + {"215":"a051c","470":"1374f","593":"8629e","724":"8a890","961":"3dfc5"}[chunkId] + ".js";
};